import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyAgenzieService
 * Client API per il pannello AMMINISTRATIVO delle agenzie nel modulo
 * "Gestione Adempimenti Sicurezza" (attivazione GAS, conteggi, impostazioni).
 * Riservato ad Admin / Superpartner.
 */
export default class SafetyAgenzieService {
    static getAll = () => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie`;
        return ApiService.getRudeRequest(url);
    };

    static show = (id_agenzia) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie/show`;
            ApiService.postRequest(resolve, reject, url, { id_agenzia });
        });
    };

    static toggleGas = (id_agenzia, safety_enabled) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie/toggle`;
            ApiService.putRequest(resolve, reject, url, { id_agenzia, safety_enabled });
        });
    };

    static updateSettings = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie/settings`;
            ApiService.putRequest(resolve, reject, url, data);
        });
    };
}
